import React, { useEffect, useRef } from 'react';
import '../style/buildRouteModal.css';
import { t } from 'i18next';

const BuildRouteModal = ({ isOpen, onClose, location }) => {
    const modalRef = useRef();

    useEffect(() => {
        const handleOverlayClick = (e) => {
            if (isOpen && modalRef.current && !modalRef.current.contains(e.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleOverlayClick);
        return () => {
            document.removeEventListener('mousedown', handleOverlayClick);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const { latitude, longitude, area, province } = location || {};
    const encodedCoords = `${latitude},${longitude}`;

    const openInMap = (type) => {
        let url = '';
        switch (type) {
            case 'yandex':
                url = `https://yandex.kz/maps/?ll=${longitude},${latitude}&z=16`;
                break;
            case 'google':
                url = `https://www.google.com/maps/search/?api=1&query=${encodedCoords}`;
                break;
            case '2gis':
                url = `https://2gis.kz/search/${latitude}%2C${longitude}`;
                break;
            default:
                break;
        }
        window.open(url, '_blank');
    };

    return (
        <div ref={modalRef} className="build_route_modal_dropdown">
            <div className="build_route_modal_header">
                <h3 className="build_route_modal_title">{t('build_route')}</h3>
            </div>
            <div className="build_route_modal_content">
                <p className="build_route_modal_location">
                    📍 {area}, {province}
                </p>
                <div className="build_route_button_group">
                    <button onClick={() => openInMap('yandex')} className="build_route_modal_button">
                        <img src="https://yandex.ru/maps/favicon.svg" alt="yandex" />
                        Yandex {t('map')}
                    </button>
                    <button onClick={() => openInMap('google')} className="build_route_modal_button">
                        <img src="https://cdn-icons-png.flaticon.com/512/2642/2642502.png" alt="google" />
                        Google {t('map')}
                    </button>
                    <button onClick={() => openInMap('2gis')} className="build_route_modal_button">
                        <img src="https://d-assets.2gis.ru/favicon.png" alt="2gis" />
                        2GIS {t('map')}
                    </button>
                </div>
            </div>
        </div>
    );

};

export default BuildRouteModal;